import styles from './batchEditCampaignSection.module.scss';
export const BatchEditCampaignSection: React.FC<
  React.PropsWithChildren<{
    title?: string;
  }>
> = ({ title, children }) => {
  return (
    <>
      {title && <div className={styles.sectionTitle}>{title}</div>}
      <div>{children}</div>
    </>
  );
};
